<template>
  <div class="box">
    <img class="logo" src="../assets/images/home/home_meiqu.png" alt="" />
    <div class="swiper">
      <swiper class="swiper_d" :options="swiperOptions">
        <swiper-slide><img src="../assets/images/home/home6.png" alt="" /></swiper-slide>
        <!-- <swiperSlide><img src="../assets/images/home/home6.png" alt="" /></swiperSlide>
        <swiperSlide><img src="../assets/images/home/home6.png" alt="" /></swiperSlide>
        <swiperSlide><img src="../assets/images/home/home6.png" alt="" /></swiperSlide>
        <swiperSlide><img src="../assets/images/home/home6.png" alt="" /></swiperSlide> -->
        <swiper-slide><img src="../assets/images/home/home27.png" alt="" /></swiper-slide>
        <swiper-slide><img src="../assets/images/home/home7.png" alt="" /></swiper-slide>
        <swiper-slide><img src="../assets/images/home/home5.png" alt="" /></swiper-slide>
        <swiper-slide><img src="../assets/images/home/home2.png" alt="" /></swiper-slide>
        <swiper-slide><img src="../assets/images/home/home3.png" alt="" /></swiper-slide>
        <swiper-slide><img src="../assets/images/home/home4.png" alt="" /></swiper-slide>
      </swiper>
    </div>
    <img class="logo_2" src="../assets/images/home/home8.png" alt="" />
    <div class="evaluate">
      <img class="logo_2" src="../assets/images/home/home9.png" alt="" />
      <img class="logo_2" src="../assets/images/home/home10.png" alt="" />
      <img class="logo_2" src="../assets/images/home/home11.png" alt="" />
    </div>
    <div class="function">
      <img src="../assets/images/home/home12.png" alt="" class="bgc" />
      <img src="../assets/images/home/home28.png" alt="" class="title" />
      <div class="fun_list">
        <div v-for="(item, index) in list">
          <img :src="item.src" alt="" />
          <span>{{ item.text }}</span>
        </div>
      </div>
    </div>
    <div class="footer" style="top: 745px">
      <img class="icon" src="../assets/images/home/home26.png" alt="" />
      <div class="text"><span>美趣AI</span><span>AI绘画写真视频一键生成</span></div>
      <div class="bottom" @click="download">立即下载</div>
    </div>
    <div class="notes">
      <span @click="goNext">重庆兴丽和科技有限公司</span>
      <span @click="goNext">渝ICP备18008214号-1</span>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      swiperOptions: {
        loop: true,
        centeredSlides: !0,
        slidesPerView: "auto",
        effect: "coverflow",
        coverflowEffect: {
          rotate: 30,
          stretch: 0,
          depth: 60,
          modifier: 1,
          slideShadows: !1,
        },
        autoplay: {
          delay: 2500,
          stopOnLastSlide: !1,
          disableOnInteraction: !1,
        },
      },
      list: [
        {
          src: require("../assets/images/home/home14.png"),
          text: "小说推文",
        },
        {
          src: require("../assets/images/home/home29.png"),
          text: "AI写真",
        },
        {
          src: require("../assets/images/home/home16.png"),
          text: "AI动漫",
        },
        {
          src: require("../assets/images/home/home17.png"),
          text: "瞬息全宇宙",
        },
        {
          src: require("../assets/images/home/home18.png"),
          text: "宝宝四维彩超",
        },
        {
          src: require("../assets/images/home/home19.png"),
          text: "动漫头像",
        },
        {
          src: require("../assets/images/home/home20.png"),
          text: "AI绘画",
        },
        {
          src: require("../assets/images/home/home30.png"),
          text: "扩展图",
        },
        {
          src: require("../assets/images/home/home22.png"),
          text: "线稿成图",
        },
        {
          src: require("../assets/images/home/home23.png"),
          text: "宫崎骏照片",
        },
        {
          src: require("../assets/images/home/home24.png"),
          text: "画质修复",
        },
        {
          src: require("../assets/images/home/home25.png"),
          text: "AI婚纱",
        },
      ],
    };
  },
  components: { swiper: Swiper, swiperSlide: SwiperSlide },
  mounted() { },

  methods: {
    goNext() {
      window.location.href = "https://beian.miit.gov.cn/";
     },
     
    download() { 
      console.log("点击了下载");  
      // 下载安装包
      const downloadUrl =
        "https://obs.xlhcq.com/biai/default/meiqi_1730170255688.apk"; 
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = "app-WKang-release.apk"; // 可以设置下载文件的名称
      // 触发点击事件
      link.click();
    }
  },
};
</script>

<style lang="scss" scoped>
.box::-webkit-scrollbar {
  display: none;
}

.box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(180deg, #dfc6fe, #86acfd);
  overflow-y: scroll;
  overflow-x: hidden;
}

.logo,
.swiper {
  width: 100vw;
}

.logo_2 {
  width: 100vw;
}

.evaluate {
  img {
    margin-top: 2.13vw;
    width: 89.33vw;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-left: 50%;
  // transform: translateX(-50%);
  width: 93.6vw;
  height: 121vw;
  background: hsla(0, 0%, 100%, 0.4);
  border-radius: 16px;
  border: 1px solid hsla(0, 0%, 100%, 0.3);
}

.function {
  margin-top: 16px;
  position: relative;
  width: 93.6vw;
  height: 109.6vw;
  // margin-left: 50%;
  // transform: translateX(-50%);
  z-index: 1;
}

.function>.bgc {
  position: absolute;
  top: 0;
  width: 93.6vw;
  height: 109.6vw;
  z-index: -1;
}

.function .title {
  margin-top: 8.64vw;
  margin-left: 50%;
  transform: translateX(-50%);
  width: 19.46vw;
  margin-bottom: 6.1333vw;
}

.function .fun_list {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 82.94vw;
  margin-left: 50%;
  transform: translateX(-50%);
}

.function .fun_list div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5.333vw;
}

.function .fun_list img {
  width: 17.867vw;
}

.function .fun_list span {
  font-size: 3.2vw;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}

.footer {
  display: flex;
  align-items: center;
  width: 100vw;
  height: 26.4vw;
  padding-top: calc((26.4vw - 15.7333vw) / 2);
  padding-bottom: calc((26.4vw - 15.7333vw) / 2);
  background: #fff;
  z-index: 99;
}

.footer .icon {
  margin-left: 12px;
  margin-right: 9px;
  width: 15.7333vw;
}

.footer .text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer .text span:first-child {
  font-size: 4.8vw;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #000;
}

.footer .text span:nth-child(2) {
  font-size: 2.9333vw;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #000;
}

.footer .bottom {
  position: absolute;
  right: 12px;
  width: 30.933vw;
  height: 11.4666vw;
  background: #000;
  border-radius: 5.6vw;
  font-size: 4.5333vw;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #fff;
  line-height: 11.4666vw;
  text-align: center;
}

.notes {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  background: #fff;
  padding-bottom: 70px;
}

.notes span {
  display: flex;
  justify-content: center;
  align-items: center;
  // font-size: 12px;
  font-size: 3.2vw;
  color: #999;
  cursor: pointer;
  text-decoration: underline; 
}

.swiper {
  width: 100vw;
}

::v-deep .swiper-container {
  width: 100vw;
}

::v-deep .swiper-wrapper {
  width: 48.666vw;
}

.swiper_d {
  height: 544px;
}

// ::v-deep .swiper-wrapper .swiper-slide img {
//   width: 48.666vw;
// }
::v-deep .swiper-wrapper .swiper-slide {
  width: 48.666vw;
  margin: 0 10px;
}

::v-deep .swiper-wrapper .swiper-slide img {
  width: 48.666vw;
}
</style>
